import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSingleLoan({
  reference,
  enabled = true,
}: {
  enabled?: boolean;
  reference: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['loans', reference], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `loans/${reference}`,
      });
      return res;
    },
    enabled,
  });
}
